import { endpoint } from "../constants";

export const putUserCheckedItems = async (accessToken, data) => {
    const requestBody = JSON.stringify({ user_checked_items: data });
    return await new Promise((resolve) => {
        fetch(endpoint, {
            method: "PUT",
            headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
            body: requestBody
        })
            .then((response) => {
                if (response.status === 401 || response.status === 403) return resolve({error: 401});
                if (response.status !== 200 && response.status !== 201) return resolve({error: response.status});
                return resolve({success: true}); 
            })
            .catch((error) => {
                return resolve({error});
            });
    });
};

export const getUserCheckedItems = async (accessToken) => {
    return await new Promise((resolve) => {
        fetch(endpoint, {
            method: "GET",
            headers: { Authorization: `Bearer ${accessToken}` }
        })
            .then(async (response) => {
                if (response.status === 204) return resolve({ status: 204 });
                return resolve({ body: await response.json() });
            })
            .catch((error) => {
                return resolve({error});
            });
    });
};
